import firebase from 'firebase/app' // eslint-disable-line
import 'firebase/app' // eslint-disable-line
import 'firebase/auth'
import firestore from 'services/firestore.js'
import storage from 'services/storage.js'
import devMode from '@/devMode.js'
import logScope from 'log-scope'
import dataLog from 'services/dataLog.js'
const log = logScope('Auth')

const authentication = {}
let storageUrl = 'gs://rideq-main.appspot.com/'

authentication.init = () => {
  // Initialize Firebase
  let config = {
    apiKey: 'AIzaSyB2YRf8GFkseGR_mBh81kR5y79g3rUbMog',
    authDomain: 'rideq-main.firebaseapp.com',
    databaseURL: 'https://rideq-main.firebaseio.com',
    projectId: 'rideq-main',
    storageBucket: storageUrl,
    messagingSenderId: '286747608349'
  }

  if (devMode.devDatabase === true) {
    log.danger('Using dev database')
    storageUrl = 'gs://rideq-dev.appspot.com/'
    config = {
      apiKey: 'AIzaSyDogVPnCBSLBnMs-HOpp0xMxzc4DWkCSII',
      authDomain: 'rideq-dev.firebaseapp.com',
      databaseURL: 'https://rideq-dev.firebaseio.com',
      projectId: 'rideq-dev',
      storageBucket: storageUrl,
      messagingSenderId: '594491260192'
    }
  }

  firebase.initializeApp(config)

  log.success('Initializing...')

  // Init admin tools
  authentication.onAuthStateChanged(() => {
    const isLoggedIn = authentication.getUser() !== null
    window.k$.isLoggedIn = isLoggedIn

    if (isLoggedIn) {
      firestore.init()
      dataLog.init()
      storage.init(storageUrl)
    }
  })
}

authentication.onAuthStateChanged = callback => {
  firebase.auth().onAuthStateChanged(() => {
    log.debug('Auth state change')
    callback()
  })
}

authentication.getUser = () => {
  return firebase.auth().currentUser
}

authentication.getToken = () => {
  const user = firebase.auth().currentUser
  return user ? user.getIdToken() : Promise.resolve('')
}

authentication.setSessionMode = () => {
  log.debug('Set session mode')
  return firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
}

authentication.signInWithEmailAndPassword = (email, password) => {
  log.debug('Sign in user: ' + email)
  return firebase.auth().signInWithEmailAndPassword(email, password)
}

authentication.createUserWithEmailAndPassword = (email, password) => {
  log.debug('Create user: ' + email)

  return firebase.auth().createUserWithEmailAndPassword(email, password)
}

authentication.signOut = () => {
  log.debug('Sign out')

  return firebase.auth().signOut()
}

if (devMode.globalShortcuts === true) {
  log.danger('Globalizing')
  window.authentication = authentication
}

export default authentication
